import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';

import '../../../components/ambassador/Ambassador.css';
import i18n from '../../../../shared/locales/no.json';
import Ambassador from '../../../components/ambassador/Ambassador.jsx';

import analytics, * as trackingTypes from '../../../actions/analyticsActions';

class AmbassadorContainer extends React.Component {
    static propTypes = {
        ambassadors: PropTypes.array,
        profileId: PropTypes.number.isRequired,
        dispatch: PropTypes.func.isRequired,
    };

    state = {
        revealed: false,
        expanded: false,
    };

    handleReveal = (e) => {
        e.preventDefault();
        this.setState({ revealed: true });
        return this.props.dispatch(analytics(trackingTypes.REVEAL_AMBASSADORS));
    };

    handleExpand = (e) => {
        e.preventDefault();
        this.setState({ expanded: true });
        return this.props.dispatch(analytics(trackingTypes.EXPAND_AMBASSADORS));
    };

    render() {
        const { ambassadors } = this.props;
        const { expanded, revealed } = this.state;

        if (!ambassadors || ambassadors.length === 0) return null;

        return (
            <section>
                <div className="panel">
                    <h2>{i18n.ambassadors.title}</h2>
                </div>
                <div className="grid t-grid grid--cols1to3">
                    {ambassadors.map((ambassador, i) => (
                        <div
                            className={classnames('grid__unit', 'unit', {
                                revealed,
                            })}
                            key={i}
                        >
                            <Ambassador
                                {...ambassador}
                                expanded={expanded}
                                onExpand={this.handleExpand}
                                onReveal={this.handleReveal}
                            />
                        </div>
                    ))}
                </div>
            </section>
        );
    }
}

export default connect((state) => state)(AmbassadorContainer);
